import { X, Share2 } from 'lucide-react';
import { useState } from 'react';

interface ReferralModalProps {
  onClose: () => void;
  referralCode: string | null;
}

export function ReferralModal({ onClose, referralCode }: ReferralModalProps) {
  const [copySuccess, setCopySuccess] = useState(false);

  const copyReferralLink = async () => {
    if (!referralCode) return;
    
    const referralLink = `${window.location.origin}/signup?ref=${referralCode}`;
    try {
      await navigator.clipboard.writeText(referralLink);
      setCopySuccess(true);
      setTimeout(() => setCopySuccess(false), 2000);
    } catch (err) {
      console.error('Failed to copy:', err);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-lg max-w-md w-full p-6 relative">
        <button 
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-500"
        >
          <X className="h-6 w-6" />
        </button>
        
        <div className="text-center mb-6">
          <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-blue-100 mb-4">
            <Share2 className="h-6 w-6 text-blue-600" />
          </div>
          <h3 className="text-lg font-medium text-gray-900 mb-2">
            Invite Friends & Get Rewards
          </h3>
          <p className="text-sm text-gray-500">
            Share your referral link with friends. When they sign up, you'll get 2 extra conversions!
          </p>
        </div>

        {referralCode && (
          <div className="space-y-4">
            <div className="flex items-center space-x-2">
              <input
                type="text"
                readOnly
                value={`${window.location.origin}/signup?ref=${referralCode}`}
                className="flex-1 p-2 border rounded-md bg-gray-50 text-sm"
              />
              <button
                onClick={copyReferralLink}
                className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors"
              >
                {copySuccess ? 'Copied!' : 'Copy'}
              </button>
            </div>
            <p className="text-xs text-gray-500 text-center">
              Your friends will get their own free conversions when they sign up!
            </p>
          </div>
        )}
      </div>
    </div>
  );
}